import styled from 'styled-components'

import { ReactComponent as QuestionMark } from '@sketch/icons/circle-question-mark-button-translucent-17'

export const Title = styled.h1`
  margin: 0 0 4px 0;
  font-size: ${({ theme }) => theme.fontSizes.H};
  font-weight: ${({ theme }) => theme.fontWeights.bold};
`

export const Description = styled.p`
  max-width: 564px;
  font-size: ${({ theme }) => theme.fontSizes.E};
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const Section = styled.section`
  display: flex;
  flex-direction: column;
  margin-bottom: 32px;
`

export const QuestionMarkIcon = styled(QuestionMark)`
  width: 17px;
  height: 17px;
  margin-right: 8px;
`

export const FootNote = styled.div`
  display: flex;
  max-width: 400px;
`

export const Divider = styled.hr`
  width: 160px;
`

export const PLACEHOLDER = styled.div`
  margin-top: 24px;
`
